import { outlook, google, ics } from "calendar-link";

export default class EventPage {
  init() {
    const eventPage = document.querySelector('.event');
    if (!eventPage) {
      return;
    }

    const dropdown = document.querySelector('.event-dropdown');
    const event = this.getEventData(dropdown);
    const baseUri = dropdown.dataset.baseUri
    document.querySelector('.event-link[data-type="outlook"]')?.setAttribute('href', outlook(event))
    document.querySelector('.event-link[data-type="google"]')?.setAttribute('href', google(event))
    document.querySelector('.event-link[data-type="ics"]')?.setAttribute('href', `${baseUri}ics-export/download.pdf?content=${ics(event).replace('data:text/calendar;charset=utf8,', '')}`)

    document.addEventListener(window.innerWidth > 600 ? 'click' : 'touchstart', (e) => {
      // on dropdown click
      if (e.target.matches('.event-dropdown')) {
        e.preventDefault();
        e.stopPropagation();
        // toggle the calendar dropdown
        e.target.classList.toggle('active');
        return;
      }
      else {
        let activeDropdown = document.querySelector('.event-dropdown.active');

        if (activeDropdown) {
            activeDropdown.classList.remove('active');
        }
      }

      // on dropdown option click
      if (e.target.matches('.event-link') && dropdown) {
        dropdown.classList.remove('active');
      }
    });
  }

  getEventData(dropdown) {
    const startDate = dropdown.getAttribute('data-start');
    let endDate = dropdown.getAttribute('data-end');
    if (!endDate) {
        endDate = new Date(startDate);
        endDate.setHours(endDate.getHours() + 1);
        endDate = endDate.toISOString();
    }
    return {
      title: dropdown.getAttribute('data-title'),
      start: startDate,
      end: endDate,
      location: dropdown.getAttribute('data-location'),
      description: dropdown.getAttribute('data-description').replaceAll('<br>', '\n')
    };
  }
}
